export const SPAN_ORIGIN_AUTO_INTERACTION = 'auto.interaction';
export const SPAN_ORIGIN_MANUAL_INTERACTION = 'manual.interaction';

export const SPAN_ORIGIN_MANUAL_APP_START = 'manual.app.start';
export const SPAN_ORIGIN_AUTO_APP_START = 'auto.app.start';

export const SPAN_ORIGIN_AUTO_NAVIGATION_REACT_NATIVE_NAVIGATION = 'auto.navigation.react_native_navigation';
export const SPAN_ORIGIN_AUTO_NAVIGATION_REACT_NAVIGATION = 'auto.navigation.react_navigation';
export const SPAN_ORIGIN_AUTO_NAVIGATION_CUSTOM = 'auto.navigation.custom';

export const SPAN_ORIGIN_AUTO_UI_TIME_TO_DISPLAY = 'auto.ui.time_to_display';
export const SPAN_ORIGIN_MANUAL_UI_TIME_TO_DISPLAY = 'manual.ui.time_to_display';
